import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import qs from "qs";

const normalizeOptionalString = (value: unknown): string | undefined => {
  if (value === null || value === undefined) return undefined;
  const str = String(value).trim();
  return str ? str : undefined;
};

export const translationsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    update: async ({ resource, id, variables, meta }) => {
      const url = "/cms/match/updateBroadcast";

      try {
        const payload: Record<string, unknown> = {
          id,
          ...variables,
        };

        const normalizedGameFnlId = normalizeOptionalString(payload.gameFnlId);
        const fallbackGameFnlId = normalizeOptionalString((meta as any)?.fnlId);
        const gameFnlId = normalizedGameFnlId ?? fallbackGameFnlId;

        if (gameFnlId) payload.gameFnlId = gameFnlId;
        else delete payload.gameFnlId;

        const { data } = await httpClient.post(url, payload);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({
      resource,
      variables,
      meta,
    }: {
      resource: string;
      variables: Record<string, unknown>;
      meta: {
        leagueId: number;
        matchId: number;
        fnlId?: number | string | null;
      };
    }) => {
      const url = "/cms/match/addBroadcast";

      const { leagueId, matchId, fnlId } = meta;
      try {
        const payload: Record<string, unknown> = {
          ...variables,
          leagueId,
          matchId,
        };

        const normalizedGameFnlId = normalizeOptionalString(payload.gameFnlId);
        const fallbackGameFnlId = normalizeOptionalString(fnlId);
        const gameFnlId = normalizedGameFnlId ?? fallbackGameFnlId;

        if (gameFnlId) payload.gameFnlId = gameFnlId;
        else delete payload.gameFnlId;

        const { data } = await httpClient.post(url, payload);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ resource, id, meta }) => {
      const url = "/cms/match/removeBroadcast";

      const { broadcastId } = meta as {
        broadcastId: number;
      };

      try {
        const { data } = await httpClient.post(
          `${url}?${qs.stringify({ broadcastId })}`
        );
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
